import { useGlobalContext } from "../Context/GlobalContext";
import Button from "../Components/button";
import { Grid2 as Grid } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Select from "../Components/select";

export const Ebike = (
    { 
        handleSave, 
        voltage, 
        setVoltage, 
        wattage, 
        setWattage, 
        isCustom, 
        toggleEbike,
        voltageOptions,
        powerOptions
    }: 
    { 
        handleSave: Function, 
        voltage: number, 
        setVoltage: Function, 
        wattage: number, 
        setWattage: Function, 
        isCustom?: boolean, 
        toggleEbike: Function,
        voltageOptions: Array<{ key: string, value: string }>,
        powerOptions: Array<{ key: string, value: string }>
    }
) => {
    const { showPopup } = useGlobalContext();

    const handleEbikeInfo = () => {
        showPopup({
            title: "E-BIKE PWR",
            content: <EbikeInfo />,  
            titleIcon: <InfoOutlinedIcon />,
        });
    }

    return (
        <div className="ebike-info">
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div style={{ display: 'flex'}}>
                    <div>E-BIKE INFO</div>
                    <span className="material-symbols-outlined" style={{fontSize: "17px", marginLeft: '10px', cursor: 'pointer'}} onClick={() => toggleEbike()}>
                        edit_square
                    </span>
                </div>
                <InfoOutlinedIcon sx={{marginTop: '-3px', fontSize: '22px', cursor: 'pointer'}} onClick={handleEbikeInfo}/>
            </div>
            <Grid container spacing={1}>
                <Grid size={{ xs: 6 }}>
                    <div style={{ margin: '5px 0'}}>VOLTAGE <br></br> {!isCustom && <span>{voltage.toFixed(1)}V</span>}</div>
                    {isCustom && <Select 
                        options={voltageOptions}
                        value={voltage.toString()}
                        setValue={setVoltage}
                    />}
                </Grid>
                <Grid size={{ xs: 6 }}>
                    <div style={{ margin: '5px 0'}}>WATTS <br></br> {!isCustom && <span>{wattage}W</span>}</div>
                    {isCustom && <Select 
                        options={powerOptions}
                        value={wattage.toString()}
                        setValue={setWattage}
                    />}
                </Grid>
                {isCustom && <Button text="SAVE" onClick={handleSave} className={"ebike-button"}/>}
            </Grid>
        </div>
    );
}

export const EbikeInfo = () => {
    return (
        <div style={{ padding: '0 20px' }}>
            <p>E-BIKE POWER CONTROLS THE VOLTAGE AND WATTS FOR YOUR BIKE LIGHT.</p>
            <p>RECOMMENDED SETTINGS HAVE BEEN AUTOAPPLIED BASED OF YOUR SELECTED E-BIKEMOTOR MAKE AND MODEL.</p>
        </div>
    )
}